import { useMutation, useQueryClient } from 'react-query'

import { userService } from 'src/services/user.service'

import { IProfileUsersResponse } from 'src/types'
import { IFilter } from 'src/components/filter/types/filter.types'

import { QUERY_KEYS } from 'src/constants'

const useRemoveUsers = (filter: IFilter) => {
  const queryClient = useQueryClient()

  return useMutation((ids: string[]) => userService.removeUsers(ids), {
    onSuccess: (data, ids) => {
      if (!data) return

      queryClient.setQueryData([QUERY_KEYS.USERS, filter], (prev?: IProfileUsersResponse) =>
        prev
          ? {
              data: prev.data.filter((item) => !ids.includes(item.id)),
              count: prev.count - ids.length,
            }
          : { data: [], count: 0 },
      )
    },
  })
}

export { useRemoveUsers }
